import React from 'react';
import { Controller } from 'react-hook-form';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { MinusIcon, PlusIcon } from '@heroicons/react/24/solid';

const CounterInput = ({ control, name, id, rules, ...props }) => {
  const defaultRules = {
    required: 'This field is required',
    min: { value: 1, message: 'Value must be at least 1' },
    valueAsNumber: true
  };

  const mergedRules = { ...defaultRules, ...rules };

  return (
    <Controller
      name={name}
      control={control}
      rules={mergedRules}
      render={({ field }) => (
        <div className='border border-input rounded-md px-2 inline-flex items-center gap-0 mt-1 bg-background w-fit'>
          <Button
            type='button'
            size='icon'
            variant='ghost'
            className='h-9 w-9 text-muted-foreground hover:bg-accent'
            onClick={() => field.onChange(Math.max(mergedRules.min.value, (field.value || mergedRules.min.value) - 1))}
            disabled={field.value <= mergedRules.min.value}
            aria-label={`Decrement ${name}`}
            {...props} // Spread additional props to the button if needed
          >
            <MinusIcon className='h-4 w-4' />
          </Button>
          <Input
            {...field}
            id={id}
            type='number'
            className='block w-12 border-0 focus:ring-0 focus:border-0 shadow-none text-center [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none bg-transparent' // Added bg-transparent
            min={mergedRules.min.value}
            onChange={(e) => {
              const num = parseInt(e.target.value, 10);
              if (!isNaN(num) && num >= mergedRules.min.value) {
                field.onChange(num);
              } else if (e.target.value === '') {
                 field.onChange(''); // Allow temporary empty state
              }
            }}
            onBlur={(e) => {
              // Reset to min value if empty or less than min on blur
              if (field.value === '' || field.value < mergedRules.min.value) {
                field.onChange(mergedRules.min.value);
              }
            }}
            aria-label={`Current value for ${name}`} // Add aria-label for input
          />
          <Button
            type='button'
            size='icon'
            variant='ghost'
            className='h-9 w-9 text-muted-foreground hover:bg-accent'
            onClick={() => field.onChange((field.value || (mergedRules.min.value -1)) + 1)} // Ensure start from min value if undefined
            aria-label={`Increment ${name}`}
            {...props} // Spread additional props to the button if needed
          >
            <PlusIcon className='h-4 w-4' />
          </Button>
        </div>
      )}
    />
  );
};

export default CounterInput; 